<template>
  <div class="overHeight" style="display: flex; flex-direction: column">
    <div
      style="
        display: flex;
        align-items: center;
        position: fixed;
        z-index: 88;
        left: 0;
        top: 3vw;
      "
    >
      <div class="changeWrap">
        <img :src="$images.change" alt="" />
        <span>切换</span>
      </div>
      <div>
        <Select
          style="width: 100px"
          placeholder="请选择年份"
          class="myselect"
          v-model="year"
        >
          <Option :value="item" v-for="item in arrYear" :key="item">{{
            item
          }}</Option>
        </Select>
        <Select
          style="width: 100px"
          placeholder="请选择月份"
          class="myselect"
          v-model="month"
        >
          <Option :value="item" v-for="item in arrMonth" :key="item">{{
            item
          }}</Option>
        </Select>
        <Button
          @click="choseYearMonth()"
          type="warning"
          ghost
          style="
            cursor: pointer;
            margin-left: 15px;
            color: #bf9d63;
            border: solid 1px #bf9d63;
          "
          >完成</Button
        >
      </div>
    </div>

    <div class="headListWrap">
      <div class="headList swiper-container" style="width: 98%">
        <div class="swiper-wrapper">
          <div
            @click="changeRiskName(item.name)"
            :class="'swiper-slide itemHead' + (item.isActive ? ' active' : '')"
            v-for="item in listHead"
            :key="item.name"
          >
            {{ item.name }}
          </div>
        </div>
        <!-- 如果需要导航按钮 -->
        <div class="swiper-button-prev"></div>
        <div class="swiper-button-next"></div>
      </div>
    </div>
    <Row class="page6 overHeight" style="flex: 1; overflow-y: hidden">
      <iframe
        :src="iframeUrl"
        frameborder="0"
        scrolling="no"
        id="external-frame"
        style="width: 100%; height: 100%"
      ></iframe>
      <Col span="4" v-if="false">
        <div class="left overHeight">
          <div class="item" v-for="item in 2" :key="item">
            <div class="father">
              <div class="titleWrap">
                <div class="titleWrapLeft">
                  <div class="icon down"></div>
                  <div class="name">付息能力指标</div>
                </div>
                <div class="dot"></div>
              </div>
              <div class="son">
                <div class="item" v-for="item in 5" :key="item">
                  <div class="name">30天现金缺口</div>
                  <div class="dot"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Col>
      <Col span="5" v-if="false">
        <div class="center overHeight">
          <div class="item" v-for="item in 3" :key="item">
            <div class="line1">
              <div class="line1">月初总货币资金</div>
              <div class="line2">百万.人民币</div>
            </div>
            <div class="line2">12345</div>
            <div class="line3">
              <div>2020同期</div>
              <div>123</div>
            </div>
          </div>
        </div>
      </Col>
      <Col span="15" class="overHeight" v-if="false">
        <div class="right overHeight"></div>
      </Col>
    </Row>
  </div>
</template>

<script>
import { useDataStore } from "@/store";
import { mapActions, mapState } from "pinia";
import Swiper from "swiper";
import "swiper/dist/css/swiper.min.css";
import "swiper/dist/js/swiper.min";
export default {
  name: "page6",
  components: {},
  created() {
    const { key1, key2, iframeurl } = this.$route.query;
    this.listHead.forEach((item, index) => {
      if (item.name == key2) {
        item.isActive = true;
        this.listHead.splice(index, 1);
        this.listHead.unshift(item);
      }
    });
    this.iframeUrl = iframeurl;
    this.setTitle(key1);
    let year = new Date().getFullYear();
    let month = new Date().getMonth() + 1;
    let day = new Date().getDate();
    if (day <= 15) {
      if (month == 1) {
        month = 11;
        year--;
      } else if (month == 2) {
        month = 12;
        year--;
      } else {
        month = month - 2;
      }
    } else {
      if (month == 1) {
        month = 12;
        year--;
      } else {
        month--;
      }
    }
    if (month < 10) {
      month = "0" + month;
    }
    this.year = year;
    this.month = month;
    let beforeYear = year - 50;
    let arrYear = [];
    while (beforeYear < year) {
      arrYear.push(year--);
    }
    this.arrYear = arrYear;
    let arrMonth = [];
    for (let i = 1; i <= 12; i++) {
      let month2 = i < 10 ? "0" + i : "" + i;
      arrMonth.push(month2);
    }
    this.arrMonth = arrMonth;
    this.choseYearMonth();
  },
  watch: {
    // 监听路由是否变化
    $route(to, from) {
      if (to.query.key2 != from.query.key2) {
        const { key2, iframeurl } = to.query;
        this.listHead.forEach((item) => {
          if (item.name == key2) {
            item.isActive = true;
          } else {
            item.isActive = false;
          }
        });
        this.iframeUrl = iframeurl;
        this.choseYearMonth();
      }
    },
  },
  data() {
    return {
      arrYear: [],
      year: "",
      month: "",
      iframeUrl: "",
      listHead: [
        {
          name: "流动性风险",
          isActive: false,
        },
        {
          name: "EBITDA",
          isActive: false,
        },
        {
          name: "食品安全风险",
          isActive: false,
        },
        {
          name: "人力资源管理风险",
          isActive: false,
        },
        {
          name: "投资管理风险",
          isActive: false,
        },
        {
          name: "汇率风险",
          isActive: false,
        },
        {
          name: "法律纠纷与诉讼风险",
          isActive: false,
        },
        {
          name: "原材料采购风险",
          isActive: false,
        },
        {
          name: "存货管理风险",
          isActive: false,
        },
        {
          name: "应收账款风险",
          isActive: false,
        },
      ],
    };
  },
  methods: {
    ...mapState(useDataStore, ["title"]),
    ...mapActions(useDataStore, ["setTitle"]),
    changeRiskName(name) {
      this.toIframe(useDataStore().title, name);
    },
    choseYearMonth() {
      if (this.iframeUrl && this.iframeUrl.indexOf("p_yearMonth") > -1) {
        this.iframeUrl =
          this.iframeUrl.substring(0, this.iframeUrl.length - 6) +
          this.year +
          this.month;
      } else {
        this.iframeUrl =
          this.iframeUrl + "&p_yearMonth=" + this.year + this.month;
      }
    },
    toIframe(key1, key2) {
      let data = {
        意大利SALOV公司: {
          流动性风险:
            "https://shanghai-yimin-no-1.cn40.analytics.sapcloud.cn/sap/fpa/ui/tenants/c7a59/bo/application/AE0130194BFD894D3FD99EF70CB9D04?mode=embed",
          食品安全风险:
            "https://shanghai-yimin-no-1.cn40.analytics.sapcloud.cn/sap/fpa/ui/tenants/c7a59/bo/application/4AE0130194BFAB14C8987F8E7E2C64C2?mode=embed",
          人力资源管理风险:
            "https://shanghai-yimin-no-1.cn40.analytics.sapcloud.cn/sap/fpa/ui/tenants/c7a59/bo/application/92E8130194B91CACFFF4957A022C8930?mode=embed",
          投资管理风险:
            "https://shanghai-yimin-no-1.cn40.analytics.sapcloud.cn/sap/fpa/ui/tenants/c7a59/bo/application/E2E8130194B83277D2DFC3C30C61CACB?mode=embed",
          汇率风险:
            "https://shanghai-yimin-no-1.cn40.analytics.sapcloud.cn/sap/fpa/ui/tenants/c7a59/bo/application/82E8130194B82AC51561D6C77CE9B2A5?mode=embed",
          法律纠纷与诉讼风险:
            "https://shanghai-yimin-no-1.cn40.analytics.sapcloud.cn/sap/fpa/ui/tenants/c7a59/bo/application/AE8130194B833FFC86CF9DD4028CF8A?mode=embed",
          原材料采购风险:
            "https://shanghai-yimin-no-1.cn40.analytics.sapcloud.cn/sap/fpa/ui/tenants/c7a59/bo/application/DAE0130194BE3483DA563AEB8E7A052F?mode=embed",
          存货管理风险:
            "https://shanghai-yimin-no-1.cn40.analytics.sapcloud.cn/sap/fpa/ui/tenants/c7a59/bo/application/4BF80A05D6EFAF978B58B0EE4A94F373?mode=embed",
          应收账款风险:
            "https://shanghai-yimin-no-1.cn40.analytics.sapcloud.cn/sap/fpa/ui/tenants/c7a59/bo/application/7BF80A05D6EF832C60C0B5260C154AD1?mode=embed",
          经营绩效风险: "XXX",
          廉洁指数:
            "https://shanghai-yimin-no-1.cn40.analytics.sapcloud.cn/sap/fpa/ui/tenants/c7a59/bo/story/73F80A05D6E846B766CBFE5C12C53E8A?mode=embed",
          EBITDA:
            "https://shanghai-yimin-no-1.cn40.analytics.sapcloud.cn/sap/fpa/ui/tenants/c7a59/bo/story/5160230194B87C54B315851002157476?mode=embed",
        },
        香港万安公司: {
          EBITDA:
            "https://shanghai-yimin-no-1.cn40.analytics.sapcloud.cn/sap/fpa/ui/tenants/c7a59/bo/story/BBF80A05D6E81B2828C3146CEBC51187?mode=embed",
          流动性风险:
            "https://shanghai-yimin-no-1.cn40.analytics.sapcloud.cn/sap/fpa/ui/tenants/c7a59/bo/application/5AE0130194BC74D2E399314B83C2640A?mode=embed",
          食品安全风险:
            "https://shanghai-yimin-no-1.cn40.analytics.sapcloud.cn/sap/fpa/ui/tenants/c7a59/bo/application/8AE0130194BC2C2DB3523AB1A84D45E4?mode=embed",
          人力资源管理风险:
            "https://shanghai-yimin-no-1.cn40.analytics.sapcloud.cn/sap/fpa/ui/tenants/c7a59/bo/application/A2E0130194BD735A6CF8846BDCFEA120?mode=embed",
          投资管理风险:
            "https://shanghai-yimin-no-1.cn40.analytics.sapcloud.cn/sap/fpa/ui/tenants/c7a59/bo/application/32E0130194BD4C5733F699B41EDD08AB?mode=embed",
          汇率风险:
            "https://shanghai-yimin-no-1.cn40.analytics.sapcloud.cn/sap/fpa/ui/tenants/c7a59/bo/application/F2E0130194BC864A96C8BA76FB1C7051?mode=embed",
          法律纠纷与诉讼风险:
            "https://shanghai-yimin-no-1.cn40.analytics.sapcloud.cn/sap/fpa/ui/tenants/c7a59/bo/application/BAE0130194BCE94F6A8DC523F204D9A4?mode=embed",
          原材料采购风险:
            "https://shanghai-yimin-no-1.cn40.analytics.sapcloud.cn/sap/fpa/ui/tenants/c7a59/bo/story/DB401B0194BE81146367898963BF3FE9?mode=embed",
          存货管理风险:
            "https://shanghai-yimin-no-1.cn40.analytics.sapcloud.cn/sap/fpa/ui/tenants/c7a59/bo/story/49A80B0194B81A7BE812C1562A9217D5?mode=embed",
          应收账款风险:
            "https://shanghai-yimin-no-1.cn40.analytics.sapcloud.cn/sap/fpa/ui/tenants/c7a59/bo/application/73F80A05D6EC8D007A52EF30ADFCA125?mode=embed",
          经营绩效风险: "XXX",
          廉洁指数:
            "https://shanghai-yimin-no-1.cn40.analytics.sapcloud.cn/sap/fpa/ui/tenants/c7a59/bo/story/BBF80A05D6E81B2828C3146CEBC51187?mode=embed",
        },
      };
      try {
        if (data[key1][key2].indexOf("http") > -1) {
          this.$router.replace({
            path: "/page6",
            query: {
              key1,
              key2,
              iframeurl: data[key1][key2],
            },
          });
        }
      } catch (error) {
        console.log(error);
      }
    },
    jump(page) {
      this.$router.push(page);
    },
    setIframeHeight() {
      const width = document.body.clientWidth;
      const myIframe = document.getElementById("external-frame");
      myIframe.style.height = width / 2.51 + "px";
    },
  },
  mounted() {
    new Swiper(".swiper-container", {
      slidesPerView: "auto",

      // 如果需要分页器
      pagination: ".swiper-pagination",
      // 如果需要前进后退按钮
      nextButton: ".swiper-button-next",
      prevButton: ".swiper-button-prev",
      // 如果需要滚动条
      // scrollbar: '.swiper-scrollbar',
      //如果需要自动切换海报
      // autoplay: {
      //   delay: 1000,//时间 毫秒
      //   disableOnInteraction: false,//用户操作之后是否停止自动轮播默认true
      // },
    });
  },
  beforeDestroy() {},
};
</script>
<style lang="less">
.swiper-button-prev {
  background-image: url("../assets/images/lr.png");
  width: 13px;
  height: 23px;
  background-size: 100% 100%;
  margin-top: -0.8vw;
}
.swiper-button-next {
  background-image: url("../assets/images/rr.png");
  width: 13px;
  height: 23px;
  background-size: 100% 100%;
  margin-top: -0.8vw;
}
.myselect {
  margin-left: 15px;
  .ivu-select-selected-value {
  }
  .ivu-select-selection {
    color: #bf9d63;
    background-color: transparent;
    border: 1px solid #bf9d63;
  }
  .ivu-select-placeholder {
    color: #bf9d63 !important;
  }
}
</style>
<style lang="less" scoped>
.changeWrap {
  display: flex;
  align-items: center;
  padding-left: 80px;
  position: relative;
  z-index: 20;
  img {
    width: 16px;
    cursor: pointer;
  }
  span {
    cursor: pointer;
    padding-left: 5px;
    font-size: 14px;
    color: #bf9d63;
  }
}
.headListWrap {
  //   width: 100%;
  //   overflow-x: auto;
  position: relative;
  z-index: 15;
  &::-webkit-scrollbar {
    width: 2px;
    height: 2px;
  }

  &::-webkit-scrollbar-track {
    background-color: transparent;
    -webkit-border-radius: 2em;
    -moz-border-radius: 2em;
    border-radius: 2em;
  }
  &::-webkit-scrollbar-thumb {
    background-color: rgb(147, 147, 153, 0.5);
    -webkit-border-radius: 2em;
    -moz-border-radius: 2em;
    border-radius: 2em;
  }
}
.headList {
  //   margin-top: 15px;
  padding-left: 30px;
  padding-right: 30px;
  display: flex;
  align-items: center;
  .itemHead {
    width: 11%;
    margin-right: 1.6vw;
    height: 2.4vw;
    background: rgba(87, 87, 87, 0.3);
    border: 1px solid #4d4a48;
    display: flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    font-size: 1vw;
    color: #ffffff;
    opacity: 0.6;
    cursor: pointer;
    &.active {
      opacity: 1;
      background: #bf9d63;
      border: 1px solid #4d4a48;
      color: #ffffff;
    }
  }
}
.page6 {
  height: 100%;
  width: 100%;
  padding-top: 25px;
  padding-left: 30px;
  padding-right: 30px;
  .right {
    height: 100%;
    background: rgba(87, 87, 87, 0.3);
  }
  .center {
    height: 100%;
    .item {
      border-right: solid 3px #000;
      border-bottom: solid 3px #000;
      padding: 15px;
      background: rgba(87, 87, 87, 0.3);
      color: #fff;
      > .line1 {
        color: #fff;
        .line1 {
          font-size: 14px;
        }
        .line2 {
          font-size: 12px;
        }
      }
      > .line2 {
        margin-bottom: 15px;
        margin-top: 15px;
        font-size: 50px;
        font-weight: 700;
        text-align: center;
      }
      > .line3 {
        display: flex;
        align-content: center;
        justify-content: space-between;
      }
    }
  }
  .left {
    font-size: 18px;
    height: 100%;
    padding-right: 40px;
    > .item {
      margin-bottom: 10px;
    }
    .father {
      .son {
        .item {
          margin-top: 10px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          .name {
            color: #fff;
            padding-left: 28px;
          }
          .dot {
            background: #eb4b3e;
            width: 14px;
            height: 14px;
            border-radius: 50%;
          }
        }
      }
      .titleWrap {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .titleWrapLeft {
          display: flex;
          align-items: center;
        }
        .name {
          color: #fff;
          padding-left: 8px;
        }
        .dot {
          background: #eb4b3e;
          width: 14px;
          height: 14px;
          border-radius: 50%;
        }
        .icon {
          position: relative;
          bottom: 3px;
          /* 用border值来控制箭头粗细 */
          border: 2px solid #1163a2;
          /* 上、右、下、左  四个边框的宽度 */
          border-width: 0px 1px 1px 0px;

          display: inline-block;
          /* padding值控制箭头大小 */
          padding: 5px;
          &.up {
            transform: rotate(-135deg);
            -webkit-transform: rotate(-135deg);
          }

          &.down {
            transform: rotate(45deg);
            -webkit-transform: rotate(45deg);
          }
        }
        .son {
        }
      }
    }
  }
}
</style>
